import React from 'react'

import ImageWithText from '@/components/flows/WalkthroughFlow/components/ImageWithText'
import screenshotUrl from '@/components/flows/WalkthroughFlow/steps/2_ProfessionalNetworkScreen1/screenshot.png'

const ProfessionalNetworkScreen1: React.FC = () => (
  <ImageWithText
    imageUrl={screenshotUrl}
    text={
      <p className="mb-4">
        See all your professional relationships in one place. Spot gaps, invite
        new firms, and grow your network. It’s free for them to join when you
        invite.
      </p>
    }
  />
)

export default ProfessionalNetworkScreen1
